import { FormattedMessage } from 'react-intl';
import { useSurveyContext } from '../Context/SurveyCustomHooks/useSurveyContext';
import { SendSurveyBtn } from './SendSurveyBtn';
import { useMediaQuery } from '@mui/material';
import { useEffect, useRef } from 'react';

export const FooterBtn = () => {
    const {
        activeStep,
        questionsNumber,
        surveyStyles,
        handleNext
    } = useSurveyContext();
    const isShortScreen = useMediaQuery('(max-height: 550px)');
    const buttonRef = useRef(null);

    useEffect(() => {
        // Focus the button when the component mounts
        if (buttonRef.current) {
            buttonRef.current.focus();
        }
    }, [activeStep]);

    return (
        <div className={`divmysurveybtn `} style={{ position: isShortScreen ? 'initial' : 'fixed' }}>
            {
                activeStep === questionsNumber - 1 ?
                    <SendSurveyBtn />
                    :
                    <button
                        ref={buttonRef}
                        type="submit"
                        style={{
                            backgroundColor: surveyStyles.btnSubmit.bg,
                            color: surveyStyles.btnSubmit.color
                        }}
                        onClick={handleNext}
                        className="btn btn-lg shadow mysurveybtn"
                    >
                        <FormattedMessage
                            id="next"
                        />
                    </button>
            }
        </div>
    )
}
